// Added by Divya
export const globalLanguagesSpokenList = [


  { name: "English", value: "english" },
  { name: "Welsh", value: "welsh" },
  { name: "British Sign Language / BSL", value: "bsl" }, // ✅ FIX
  { name: "Irish", value: "irish" },
  { name: "Scottish Gaelic", value: "scottish_gaelic" },

  { name: "Hindi", value: "hindi" },
  { name: "Urdu", value: "urdu" },
  { name: "Punjabi", value: "punjabi" },
  { name: "Gujarati", value: "gujarati" },
  { name: "Bengali", value: "bengali" },
  { name: "Sylheti", value: "sylheti" },
  { name: "Tamil", value: "tamil" },
  { name: "Telugu", value: "telugu" },
  { name: "Malayalam", value: "malayalam" },
  { name: "Kannada", value: "kannada" },
  { name: "Marathi", value: "marathi" },
  { name: "Nepali", value: "nepali" },
  { name: "Sinhala", value: "sinhala" },
  { name: "Pashto", value: "pashto" },
  { name: "Dari", value: "dari" },
  { name: "Farsi / Persian", value: "farsi" }, // ✅ FIX

  { name: "Somali", value: "somali" },
  { name: "Swahili", value: "swahili" },
  { name: "Yoruba", value: "yoruba" },
  { name: "Igbo", value: "igbo" },
  { name: "Hausa", value: "hausa" },
  { name: "Amharic", value: "amharic" },
  { name: "Tigrinya", value: "tigrinya" },
  { name: "Oromo", value: "oromo" },
  { name: "Akan / Twi", value: "akan_twi" },
  { name: "Shona", value: "shona" },
  { name: "Ndebele", value: "ndebele" },
  { name: "Lingala", value: "lingala" },
  { name: "Kinyarwanda", value: "kinyarwanda" },
  { name: "Zulu", value: "zulu" },
  { name: "Afrikaans", value: "afrikaans" },

  { name: "Arabic", value: "arabic" },
  { name: "Kurdish", value: "kurdish" },
  { name: "Turkish", value: "turkish" },
  { name: "Hebrew", value: "hebrew" },
  { name: "Berber / Amazigh", value: "berber_amazigh" },

  { name: "Polish", value: "polish" },
  { name: "Romanian", value: "romanian" },
  { name: "Lithuanian", value: "lithuanian" },
  { name: "Latvian", value: "latvian" },
  { name: "Russian", value: "russian" },
  { name: "Ukrainian", value: "ukrainian" },
  { name: "Bulgarian", value: "bulgarian" },
  { name: "Czech", value: "czech" },
  { name: "Slovak", value: "slovak" },
  { name: "Hungarian", value: "hungarian" },
  { name: "Albanian", value: "albanian" },
  { name: "Serbian", value: "serbian" },
  { name: "Croatian", value: "croatian" },
  { name: "Bosnian", value: "bosnian" },
  { name: "Greek", value: "greek" },
  { name: "Italian", value: "italian" },
  { name: "Spanish", value: "spanish" },
  { name: "Portuguese", value: "portuguese" },
  { name: "French", value: "french" },
  { name: "German", value: "german" },
  { name: "Dutch", value: "dutch" },

  { name: "Mandarin Chinese", value: "mandarin" }, // ✅ FIX
  { name: "Cantonese", value: "cantonese" },
  { name: "Vietnamese", value: "vietnamese" },
  { name: "Thai", value: "thai" },
  { name: "Filipino / Tagalog", value: "tagalog" }, // ✅ FIX
  { name: "Malay", value: "malay" },
  { name: "Indonesian", value: "indonesian" },
  { name: "Japanese", value: "japanese" },
  { name: "Korean", value: "korean" },
  { name: "Burmese", value: "burmese" },
  { name: "Khmer", value: "khmer" },
  { name: "Lao", value: "lao" },

  { name: "Other", value: "other" }, // ✅ FIX
  { name: "Prefer not to say", value: "prefer_not_to_say" },
];